import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a424acc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("主题")
const _hoisted_2 = { class: "flex flex-jc-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("导航栏模式")
const _hoisted_4 = { class: "flex flex-jc-sb flex-jc-sa navigation-bar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-aside" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "setting-header" })
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "setting-header" })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "theme-color" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("主题色")
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = ["onClick"]

import { ref, computed } from 'vue';
import { SettingOutlined } from '@ant-design/icons-vue';
import { useLayoutStoreHook } from '@/store/modules/layout';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const layoutStore = useLayoutStoreHook();
const settingShow = ref(false);

const onToggle = (layout: 'vertical' | 'horizontal') => {
  layoutStore.toggleLayout(layout);
};
const onToggleTheme = (themeType: string) => {
  layoutStore.toggleThemeStyle(themeType);
};
const theme = computed({
  get() {
    return layoutStore.theme;
  },
  set(nvl) {
    layoutStore.toggleTheme(nvl as 'light' | 'dark');
  },
});

return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      class: "fd-setting",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (settingShow.value = true))
    }, [
      _createVNode(_unref(SettingOutlined))
    ]),
    _createVNode(_component_a_drawer, {
      title: "Setting",
      visible: settingShow.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((settingShow).value = $event)),
      class: "setting-drawer"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createVNode(_component_a_divider, null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_switch, {
                "checked-value": "dark",
                "un-checked-value": "light",
                "checked-children": "dark",
                "un-checked-children": "light",
                checked: _unref(theme),
                "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => (_isRef(theme) ? (theme).value = $event : null))
              }, null, 8, ["checked"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_a_divider, null, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createElementVNode("ul", _hoisted_4, [
              _createElementVNode("li", {
                class: _normalizeClass(["navigation-bar-item cursor-pointer flex flex-jc-sb vertical", {
              active: _unref(layoutStore).layout === 'vertical',
            }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onToggle('vertical')))
              }, _hoisted_7, 2),
              _createElementVNode("li", {
                class: _normalizeClass(["navigation-bar-item cursor-pointer horizontal", {
              active: _unref(layoutStore).layout === 'horizontal',
            }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (onToggle('horizontal')))
              }, _hoisted_9, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_a_divider, null, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createElementVNode("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(layoutStore).themeColorMap, (theme, k) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: theme,
                  class: _normalizeClass({
              'theme-color-item': true,
              [k]: true,
              'theme-color-active': _unref(layoutStore).themeStyle === k,
            }),
                  style: _normalizeStyle({ background: theme }),
                  onClick: ($event: any) => (onToggleTheme(k))
                }, null, 14, _hoisted_13))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})